import { useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import { Toaster } from './components/ui/sonner';
import { Helmet } from 'react-helmet';

function App() {
  return (
    <div className="App">
      <Helmet>
        <title>Free LLM API Key Tester - OpenAI, Anthropic, Gemini | Secure & Fast</title>
        <meta name="description" content="Securely test your AI API keys in seconds. Validate OpenAI, Anthropic Claude, and Google Gemini keys with real-time connectivity checks, model listings, and latency metrics. 100% client-side, no storage." />
        <meta name="keywords" content="LLM API key tester, OpenAI API validator, Claude API test, Gemini API check, AI key verification, API key security, test GPT key, validate anthropic key" />
        <meta property="og:title" content="Free LLM API Key Tester - Test OpenAI, Claude & Gemini Keys" />
        <meta property="og:description" content="Secure client-side API key testing for major LLM providers. No storage, instant results." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Free LLM API Key Tester" />
        <meta name="twitter:description" content="Test your AI API keys securely - OpenAI, Claude, Gemini. Client-side only, no data stored." />
        
        
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            "name": "LLM API Key Tester",
            "applicationCategory": "DeveloperApplication",
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "USD"
            },
            "description": "Free tool to test and validate LLM API keys from OpenAI, Anthropic, and Google Gemini with client-side security.",
            "operatingSystem": "Any",
            "permissions": "No data collection or storage"
          })}
        </script>
      </Helmet>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" expand={false} richColors />
    </div>
  );
}

export default App;